import { ReactElement } from 'react'

import { ALL_ROUTES } from '../constants/route-configs.constants'

export type RouteConfig = {
  key: string
  path: string
  requiresAuth: boolean
  label: string
  element: ReactElement
  policy?: string | null
  showInMenu: boolean
  menuConfig?: {
    icon?: string
    order?: number
    platforms?: string[]
  }
  parentKey?: string
}

export type MenuConfigBase = {
  id: string
  path: string
  title: string
  icon?: string
  policy?: string | null
}

export type DefaultMenuConfig = MenuConfigBase

export type NavigationOptions = {
  includeOrgPrefix?: boolean
  hardRedirect?: boolean
  skipValidation?: boolean
  replace?: boolean
}

export type RouteKey = keyof typeof ALL_ROUTES

export type RouteParams = {
  [K in RouteKey]?: Record<string, string>
}

export type RoutesWithParams = {
  LEAD_DETAIL: { personId: string }
  LEAD_DETAIL_V1: { personId: string }
  ACCOUNT_DETAIL: { personId: string }
  ACCOUNT_DETAIL_V1: { personId: string }
  SEARCH: { searchValue: string }
  LIST_BUILDER_DETAIL: { listId: string }
  CUSTOM_PATH: { path: string }
}

export enum DEFAULT_ROUTES {
  ACCOUNTS = 'ACCOUNTS',
  ACCOUNT_DETAIL = 'ACCOUNT_DETAIL',
  ACCOUNT_DETAIL_V1 = 'ACCOUNT_DETAIL_V1',
  ADMINISTRATION = 'ADMINISTRATION',
  ADMINISTRATION_ABCS = 'ADMINISTRATION_ABCS',
  ADMINISTRATION_EMAIL_TEMPLATE = 'ADMINISTRATION_EMAIL_TEMPLATE',
  ADMINISTRATION_EMAIL_TEMPLATE_CREATE = 'ADMINISTRATION_EMAIL_TEMPLATE_CREATE',
  ADMINISTRATION_EMAIL_TEMPLATE_DETAIL = 'ADMINISTRATION_EMAIL_TEMPLATE_DETAIL',
  ADMINISTRATION_POLICIES = 'ADMINISTRATION_POLICIES',
  ADMINISTRATION_ROLES = 'ADMINISTRATION_ROLES',
  ADMINISTRATION_ROLES_DETAIL = 'ADMINISTRATION_ROLES_DETAIL',
  ADMINISTRATION_TAGS = 'ADMINISTRATION_TAGS',
  ADMINISTRATION_USERS = 'ADMINISTRATION_USERS',
  ADMINISTRATION_USERS_CREATE = 'ADMINISTRATION_USERS_CREATE',
  ADMINISTRATION_USERS_DETAILS = 'ADMINISTRATION_USERS_DETAILS',
  ADMINISTRATION_FORM_BUILDER = 'ADMINISTRATION_FORM_BUILDER',
  DASHBOARD = 'DASHBOARD',
  DATA_PROCESSING = 'DATA_PROCESSING',
  ESCALATIONS = 'ESCALATIONS',
  FORM_SUBMISSIONS = 'FORM_SUBMISSIONS',
  FORM_SUBMISSIONS_DETAIL = 'FORM_SUBMISSIONS_DETAIL',
  LEADS = 'LEADS',
  LEAD_CREATE = 'LEAD_CREATE',
  LEAD_DETAIL = 'LEAD_DETAIL',
  LEAD_DETAIL_V1 = 'LEAD_DETAIL_V1',
  MERGING_TOOL = 'MERGING_TOOL',
  REPORTS = 'REPORTS',
  SEARCH = 'SEARCH',
  SMS_CAMPAIGNS = 'SMS_CAMPAIGNS',
  SMS_CAMPAIGNS_CREATE = 'SMS_CAMPAIGNS_CREATE',
  SMS_CAMPAIGNS_DETAIL = 'SMS_CAMPAIGNS_DETAIL',
  COMMUNICATIONS_HUB = 'COMMUNICATIONS_HUB',
  COMMUNICATIONS_HUB_SMS_CAMPAIGN = 'COMMUNICATIONS_HUB_SMS_CAMPAIGN',
  COMMUNICATIONS_HUB_SMS_CAMPAIGN_CREATE = 'COMMUNICATIONS_HUB_SMS_CAMPAIGN_CREATE',
  COMMUNICATIONS_HUB_SMS_CAMPAIGN_EDIT = 'COMMUNICATIONS_HUB_SMS_CAMPAIGN_EDIT',
  COMMUNICATIONS_HUB_SMS_CAMPAIGN_DETAIL = 'COMMUNICATIONS_HUB_SMS_CAMPAIGN_DETAIL',
  COMMUNICATIONS_HUB_SMS_CAMPAIGN_TODO = 'COMMUNICATIONS_HUB_SMS_CAMPAIGN_TODO',
  TASKS = 'TASKS',
  TICKETS = 'TICKETS',
  UPLOAD_FILE = 'UPLOAD_FILE',
  TEAM_LEAD_HUB = 'TEAM_LEAD_HUB',
  CLINICS = 'CLINICS',
  CLINIC_DETAIL = 'CLINIC_DETAIL',
  LOCATIONS = 'LOCATIONS',
  ENROLLMENT_CHECKER = 'ENROLLMENT_CHECKER',
  RECENT_VIEWED = 'RECENT_VIEWED',
  WEB_SITES = 'WEB_SITES',
  LIST_BUILDER = 'LIST_BUILDER',
  LIST_BUILDER_CREATE = 'LIST_BUILDER_CREATE',
  LIST_BUILDER_DETAIL = 'LIST_BUILDER_DETAIL',
}
